import { Card, CardContent, Stack, Avatar, Box, Typography, Tooltip } from '@mui/material';
import { FilterAlt as FilterAltIcon } from '@mui/icons-material';
import { themeConstants } from '@/theme';

interface MetricsStatCardProps {
    label: string;
    value: number | string;
    icon: React.ReactNode;
    color: string;
    gradient: string;
    border: string;
    suffix?: string;
    filtered?: boolean;
    filteredLabel?: string;
}

export const MetricsStatCard = ({
    label,
    value,
    icon,
    color,
    gradient,
    border,
    suffix,
    filtered,
    filteredLabel = 'Filtered by user',
}: MetricsStatCardProps) => (
    <Card
        sx={{
            background: gradient,
            border,
            position: 'relative',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            transition: themeConstants.transitions.smooth,
            '&:hover': { boxShadow: themeConstants.effects.boxShadowHover },
        }}
    >
        {filtered && (
            <Tooltip title={filteredLabel} placement="top">
                <FilterAltIcon
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        fontSize: 14,
                        color: 'text.disabled',
                        opacity: 0.6,
                    }}
                />
            </Tooltip>
        )}
        <CardContent>
            <Stack direction="row" sx={{ alignItems: 'center', gap: 2 }}>
                <Avatar sx={{ bgcolor: color }}>{icon}</Avatar>
                <Box>
                    <Typography variant="h4" fontWeight={700}>
                        {value}
                        {suffix && (
                            <Typography
                                component="span"
                                variant="body2"
                                color="text.secondary"
                                sx={{ ml: 0.5 }}
                            >
                                {suffix}
                            </Typography>
                        )}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {label}
                    </Typography>
                </Box>
            </Stack>
        </CardContent>
    </Card>
);
